// Shopify Buy SDK integration — loads the SDK lazily, creates a checkout
// for the configured product, and redirects to Shopify's hosted checkout.

const SHOPIFY_DOMAIN = 'ch00br-q0.myshopify.com'
const STOREFRONT_ACCESS_TOKEN = 'b940db7edf38442fb933bed97eb9c418'
const PRODUCT_ID = '9363492012246'

let sdkPromise: Promise<any> | null = null

function loadSDK(): Promise<any> {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('Shopify SDK can only load in the browser'))
  }
  if ((window as any).ShopifyBuy) {
    return Promise.resolve((window as any).ShopifyBuy)
  }
  if (sdkPromise) return sdkPromise

  sdkPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.async = true
    script.src =
      'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js'
    script.onload = () => {
      const SB = (window as any).ShopifyBuy
      if (SB) resolve(SB)
      else reject(new Error('Shopify SDK failed to expose ShopifyBuy'))
    }
    script.onerror = (err) => {
      sdkPromise = null
      reject(err)
    }
    document.head.appendChild(script)
  })

  return sdkPromise
}

export async function startCheckout(): Promise<void> {
  try {
    const ShopifyBuy = await loadSDK()
    const client = ShopifyBuy.buildClient({
      domain: SHOPIFY_DOMAIN,
      storefrontAccessToken: STOREFRONT_ACCESS_TOKEN,
    })

    // The Storefront API uses Global IDs (GIDs).
    const productGid = `gid://shopify/Product/${PRODUCT_ID}`
    const product = await client.product.fetch(productGid)
    const variantId = product.variants[0].id

    const checkout = await client.checkout.create()
    const updated = await client.checkout.addLineItems(checkout.id, [
      { variantId, quantity: 1 },
    ])

    window.location.href = updated.webUrl
  } catch (err) {
    console.error('Shopify checkout error', err)
    // Fallback: open the storefront product page so the user can still buy.
    window.location.href = `https://${SHOPIFY_DOMAIN}/products/`
  }
}
